import { render, staticRenderFns } from "./UserNotfound.vue?vue&type=template&id=f0f09a72&"
import script from "./UserNotfound.vue?vue&type=script&lang=js&"
export * from "./UserNotfound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports